import Vue from "vue";

import {registerBookingModules} from "./booking";
import {registerCampsitesFilter} from "./filter-campsites";
import {registerArrangementenFilter} from "./filter-arrangement";
import {registerExpandableContent} from "./expandable-content";
import {registerGoogleMaps} from "./google-maps";
import {registerHeader} from "./header";
import {registerScrollTo} from "./scroll-to";
import {registerSearch} from "./search";
import {initializeSliders} from "./slider";
import {registerSocialCorner} from "./social";
import {registerTabs} from "./tabs";

import * as Components from "./component";

import "../scss/style.scss";

import "./polyfill";
import "./outside-event";
import "./reservation";

function initializeCollapse()
{
	Array
		.from(document.querySelectorAll(`[data-toggle="collapse"]`))
		.forEach(toggle => {
			const target = toggle.dataset.target;

			if (!target)
				return;

			toggle.addEventListener("click", evt => {
				evt.preventDefault();
				evt.stopPropagation();

				document.querySelector(target).classList.toggle("show");
			});
		});
}

function initializeCookies()
{
	function dialog()
	{
		return document.querySelector("#cookie-consent");
	}

	function handleButton(fn)
	{
		return evt => {
			evt.preventDefault();
			evt.stopPropagation();

			fn && fn();
		};
	}

	function setCookie(accepted)
	{
		const days = 60, date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

		const expires = `expires=${date["toGMTString"]()}`;

		document.cookie = `euregio_cookie_consent=${accepted ? 1 : 0}; ${expires}; path=/`;

		const d = dialog();
		d.classList.add("is-hiding");
		setTimeout(() => d.remove(), 540);
	}

	const allowButton = document.querySelector("#allow-cookie");
	const disallowButton = document.querySelector("#disallow-cookie");
	const privacyButton = document.querySelector("#privacy-cookie");

	if (allowButton && disallowButton && privacyButton)
	{
		allowButton.addEventListener("click", handleButton(() => setCookie(true)));
		disallowButton.addEventListener("click", handleButton(() => setCookie(false)));
		privacyButton.addEventListener("click", handleButton(() => dialog().classList.toggle("is-privacy-open")));
	}
}

function initializeMenu()
{
	Array
		.from(document.querySelectorAll("li.nav-item.dropdown"))
		.forEach(item => {
			const link = item.querySelector("a.nav-link.dropdown-toggle");
			const menu = item.querySelector("ul.dropdown-menu");

			let shouldDisplayDropdown = false;

			link.addEventListener("touchstart", () => {
				if (!!(menu.offsetWidth || menu.offsetHeight || menu.getClientRects().length))
					return;

				shouldDisplayDropdown = true;
			});

			link.addEventListener("click", evt => {
				console.log(shouldDisplayDropdown);

				if (shouldDisplayDropdown === true)
				{
					evt.preventDefault();
					evt.stopPropagation();
				}

				shouldDisplayDropdown = false;
			});
		});
}

export function initializeWeb()
{
	registerBookingModules();
	registerCampsitesFilter();
	registerArrangementenFilter();
	registerExpandableContent();
	registerGoogleMaps();
	registerHeader();
	registerScrollTo();
	registerSearch();
	initializeSliders();
	registerSocialCorner();
	registerTabs();

	Object.values(Components).forEach(c => Vue.component(c.name, c));

	new Vue({
		el: "#root"
	});

	initializeCollapse();
	initializeCookies();
	initializeMenu();

	moment.locale(hcdcI18n.locale);

	window.initMap = () => {
	};

	jQuery(document).ready(function () {
		jQuery('button#launch-newsletter-modal').on('click', function () {
			jQuery('#newsletter-modal').modal('show');
		});

		jQuery('button#launch-brochure-modal').on('click', function () {
			jQuery('#brochure-modal').modal('show');
		});
	});
}
